import React from 'react';
import { ChannelBuckets } from '../../utils/channelBuckets';

const chatChannelListContextInitialState = {
  isReady: false,
  channelList: [],
  channelUnreadCounts: {},
  loadMoreChannels: () => {},
  isLoadingChannels: false,
  hasMoreChannels: true,
  selectedBucket: ChannelBuckets.ACTIVE,
  setSelectedBucket: () => {},
  searchTerm: '',
  setSearchTerm: () => {},
  isRecentFirst: true,
  setIsRecentFirst: () => {},
  isCustomSortEnabled: false,
  setIsCustomSortEnabled: () => {},
  activeUserId: '',
  setActiveUserId: () => {},
  totalUnreadCount: 0,
  archiveChats: async () => {},
  claimedChannelCollection: { docs: [] },
  pendingChannelCount: 0,
  userUnreadCounts: {},
};

const ChatChannelListContext = React.createContext(chatChannelListContextInitialState);

export default ChatChannelListContext;
export {
  chatChannelListContextInitialState,
};
